var classes = {"contentCard":"_0eu4F","contentCardFigure":"cdz-Z","contentCardTitle":"OYi-t","contentCardDescription":"iau9k","contentCardLink":"ALFoY"};

export { classes as default };
